export const Vocabulary = {
  back: 'Înapoi',
  continue: 'Continuă',
  finalizeOrder: 'Finalizează comanda',
  requiredField: 'Acest câmp este obligatoriu',
  invalidEmail: 'Adresa de email nu este validă',
  invalidPhone: 'Telefonul trebuie să conțină 10 cifre',
  pickupDatePast: 'Data de ridicare trebuie să fie în viitor',
  selectAtLeastOne: 'Selectați cel puțin o reparație sau descrieți problema',

  stepManufacturer: 'Selectați categoria',
  stepDevice: 'Ce doriți să reparați?',
  stepDeviceSubtitle: 'Selectați dispozitivul din lista de mai jos',
  stepRepairs: 'Selectați ce doriți să reparați din listă',
  stepRepairsSubtitle: 'Sau completați detaliile problemei întâmpinate pentru evaluare.',
  stepDelivery: 'Date livrare & date client',
  stepOf: (current: number, total: number) => `Pasul ${current} din ${total}`,

  searchDevice: 'Caută dispozitiv',
  noDevicesFound: 'Nu au fost găsite dispozitive',
  noRepairsFound: 'Nu există reparații predefinite pentru acest dispozitiv',

  repairName: 'Reparație',
  spareParts: 'Piese de schimb',
  totalPrice: 'Preț total',
  ron: 'RON',
  existingRepairDetails: 'Detalii reparație',
  existingRepairDetailsHint: 'Completați dacă doriți să adăugați detalii suplimentare',
  otherProblem: 'Altă problemă',
  otherProblemDescription: 'Descrieți problema',

  clientInfo: 'Date client',
  clientName: 'Nume și prenume',
  clientEmail: 'Email',
  clientPhone: 'Telefon',

  shipping: 'Informații livrare',
  pickupDate: 'Data de ridicare',
  county: 'Județ',
  city: 'Localitate',
  street: 'Stradă',
  streetNumber: 'Număr',
  zipCode: 'Cod poștal',
  details: 'Detalii adresă',

  orderSuccess: 'Comanda a fost plasată cu succes!',
  orderSuccessSubtext: 'Veți fi contactat în curând pentru a stabili detaliile reparației.',
  goToGlassGSM: 'Mergi pe glassgsm.ro',
  orderNumber: 'Număr comandă',

  error: 'A apărut o eroare. Vă rugăm încercați din nou.',
  loading: 'Se încarcă...',
  brandNotFound: 'Categoria căutată nu a fost găsită.',
  modelNotFound: 'Dispozitivul căutat nu a fost găsit.',
};
